import React from 'react';
import { IssueItem } from '../../models/issueItem';
import './IssuesTable.css';

interface IssueCardProps {
  issue: IssueItem;
}

const IssueCard: React.FC<IssueCardProps> = ({ issue }) => {
  return (
    <div>
      <div className="issue-card-id">#{issue.id}</div>
      <div className="issue-card-title">{issue.title}</div>
      <div className="issue-card-link">
        <a
          href={issue.link}
          target="_blank"
          className="text-blue-500 hover:text-blue-800"
        >
          {issue.link}
        </a>
      </div>
      <p>Start At: {issue.start_at}</p>
      <p>End At: {issue.end_at}</p>
      <p>Count: {issue.count}</p>
      {/* <p>Status: {issue.status}</p> */}
    </div>
  );
};

export default IssueCard;
